
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","fill-rule":"evenodd","d":"M7.704 3a4.704 4.704 0 013.797 7.481l2.201 2.202a.707.707 0 01-1 1l-2.199-2.198A4.704 4.704 0 117.704 3zm0 1.414a3.29 3.29 0 100 6.58 3.29 3.29 0 000-6.58z"}})])
          )
        }
      }
    